import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger, MorphSVGPlugin } from 'gsap/all';
require("../__vendor/SplitText.min.js");

gsap.registerPlugin(CSSRulePlugin, ScrollTrigger); 

const about = () => {
    new SplitText(".about-main--text h2", {
        type: "words",
        wordsClass: "word word++"
    });

    new SplitText(".about-info--text h2", {
        type: "lines",
        linesClass: "line line++"
    });

    new SplitText(".team h2", {
        type: "lines",
        linesClass: "line line++"
    });
};

export default about;